export default "__VITE_ASSET__b44d6c24__"